import React from 'react';
import PropTypes from 'prop-types';
import {
  ClassIcon,
  GroupIcon,
  StudentIcon
} from '../../../../../../helpers/icon-dictionary';

const DoughnutsClassroomIcon = ({ type }) => {
  const icons = [
    <img src={ClassIcon} alt="class icon" />,
    <img src={GroupIcon} alt="group icon" />,
    <img src={StudentIcon} alt="student icon" />
  ];

  return icons[type];
};

DoughnutsClassroomIcon.propTypes = {
  type: PropTypes.number
};

export default DoughnutsClassroomIcon;



// WEBPACK FOOTER //
// ./components/student-list/student-modal/student-result/doughnut-chart/doughnut-classroom-icon/doughnut-classroom-icon.js